import React, { useEffect } from "react";
import { connect } from "react-redux";
import { fetchAgents } from "../../processes/agentProcesses";
import {
  getAgentsList,
  isAgentsListLoading,
} from "../../selectors/agentSelectors";
import AgentsList from "./AgentsList";

function AgentsListContainer(props) {
  const { dispatch } = props;

  useEffect(() => {
    fetchAgents(dispatch);
  }, [dispatch]);

  return <AgentsList {...props} />;
}

function mapStateToProps(state) {
  return {
    agents: getAgentsList(state),
    loading: isAgentsListLoading(state),
  };
}

export default connect(mapStateToProps)(AgentsListContainer);
